import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export const comsText1Template = (
  node: HTMLElement,
) => html`<em>${unsafeHTML(node.innerHTML)}</em>`;

export const comsText2Template = (
  node: HTMLElement,
) => html`<strong><em>${unsafeHTML(node.innerHTML)}</em></strong>`;

export const comsText3Template = (
  node: HTMLElement,
) => html`<one-text spaced>${unsafeHTML(node.innerHTML)}</one-text>`;
